import { render, staticRenderFns } from "./noAppIcon.vue?vue&type=template&id=475cbb62&"
import script from "./noAppIcon.vue?vue&type=script&lang=js&"
export * from "./noAppIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports